import type { FC, PropsWithChildren } from "react";
import { createContext, useContext } from "react";
import { useAccount, usePublicClient } from "wagmi";

import type { EthFaucetState } from "./useEthFaucet";
import useEthFaucet from "./useEthFaucet";
import type { UseTokenBalances } from "./useTokenBalances";
import { useTokenBalances } from "./useTokenBalances";

export interface MyAssetsContext {
  tokens: UseTokenBalances;
  native: EthFaucetState;
}

const Ctx = createContext<MyAssetsContext>({
  tokens: { loading: true, retry: () => {} },
  native: {
    balance: "-",
    loading: false,
    requesting: false,
    requestEth: () => {},
    refresh: () => {},
  },
});

export const MyAssetsProvider: FC<PropsWithChildren> = ({ children }) => {
  const { address: account } = useAccount();
  const publicClient = usePublicClient();
  const tokens = useTokenBalances(publicClient, account);
  const native = useEthFaucet();
  return <Ctx.Provider value={{ tokens, native }}>{children}</Ctx.Provider>;
};

export const useMyAssets = () => useContext(Ctx);
